import { Injectable } from '@angular/core';

import { Observable, filter, map } from 'rxjs';

import {
  DepositEvent,
  User,
  UserUpdatedEvent,
  UserVerifiedEvent,
  WebsocketEvent,
  WebsocketEventType,
  DepositStatsModel,
  UserSocketVerificationStatus,
} from '@personal-area/global/users/models';
import {
  WebsocketClient,
  WebsocketFactory,
  socketUrls,
} from '@personal-area/global/websocket';

@Injectable()
export class UserSocketService {
  private _client: WebsocketClient;

  constructor(private readonly _factory: WebsocketFactory) {}

  public connect() {
    this._client = this._factory.create(socketUrls.base, 'user').useAuth();

    this._client.init();
  }

  public get depositStats(): Observable<DepositStatsModel> {
    return this._client.output<{ result: WebsocketEvent<DepositEvent> }>().pipe(
      filter(
        (event) =>
          event.result.eventType === WebsocketEventType.UserDepositStatsUpdated,
      ),
      map((event) => event.result.response.depositAccepted),
    );
  }

  public get userUpdated(): Observable<User> {
    const events = [
      WebsocketEventType.UserUpdated,
      WebsocketEventType.UserEmailConfirmed,
      WebsocketEventType.UserBlocked,
    ];
    return this._client
      .output<{ result: WebsocketEvent<UserUpdatedEvent> }>()
      .pipe(
        filter((event) => events.includes(event.result.eventType)),
        map((event) => event.result.response.user),
      );
  }

  public get userVerified(): Observable<UserSocketVerificationStatus> {
    return this._client
      .output<{ result: WebsocketEvent<UserVerifiedEvent> }>()
      .pipe(
        filter(
          (event) => event.result.eventType === WebsocketEventType.UserVerified,
        ),
        map((event) => event.result.response.verification),
      );
  }
}
